import React from "react";
import { Button, TextField, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

export default function ProductsToolbar({ searchTerm, onSearchChange, onAddClick }) {
  return (
    <>
      <Button
        startIcon={<AddIcon />}
        variant="contained"
        color="secondary"
        onClick={onAddClick}
        sx={{ "& .MuiButton-startIcon": { marginRight: 1 } }}
      >
        הוסף מוצר
      </Button>

      <TextField
        label="חיפוש מוצר"
        variant="outlined"
        fullWidth
        sx={{ my: 2 }}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}
